import { Injectable } from '@angular/core';
import { IPagination } from '../../../../shared/services/api/interface/pagination.interface';
import { Observable } from 'rxjs';
import { ApiService } from '../../../../shared/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class EmailTemplateService {
  constructor(private readonly apiService: ApiService) {}

  getAll() {
    return this.apiService.get<any>('email-template');
  }

  getAllFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(
      `email-template/filter-list`,
      { event: event, filter: filter }
    );
  }

  create(data: any) {
    return this.apiService.post('email-template/create', data);
  }

  update(data: any) {
    return this.apiService.put('email-template/update', data);
  }

  delete(id: number) {
    return this.apiService.delete(`email-template/delete/${id}`);
  }

  getById(id: number) {
    return this.apiService.get(`email-template/${id}`);
  }
}
